{
    "name": "idle",
    "duration": 1.33333337,
    "keyframes": {
        "/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "/m_LocalPosition.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalPosition.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalPosition.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalScale.x": [
            1.0, 1.00354111, 1.01090944, 1.02048564, 1.03065, 1.03978324, 1.0462656,
            1.04847777, 1.04479992, 1.03610277, 1.02553892, 1.01491189, 1.006025, 1.00068188
        ],
        "/m_LocalScale.y": [
            1.0, 0.998412848, 0.9842369, 0.961907148, 0.9358587, 0.910526454, 0.890345454,
            0.879750669, 0.883177042, 0.900066, 0.9240401, 0.950805962, 0.976070344,
            0.9955399
        ],
        "/m_LocalScale.z": [
            1.0, 1.00354111, 1.01090944, 1.02048564, 1.03065, 1.03978324, 1.0462656,
            1.04847777, 1.04479992, 1.03610277, 1.02553892, 1.01491189, 1.006025, 1.00068188
        ]
    },
    "wrapMode": 2,
    "guid": "995f719cce6be47a39224b917c5df696",
    "assetPath": "Assets/Characters/Mal/mal@idle.fbx"
}
